
import { VRRoom } from '../components/vrRoom3';
import { loadSceneforDesktop } from '../components/room1';

export function checkForImmersiveVR() {

    let details = navigator.userAgent
    let regexp = /android|iphone|kindle|ipad/i;

    let isMobileDevice = regexp.test(details);
    if (isMobileDevice) {
        loadSceneforDesktop();
    } else {
        //checkForDesktopOrVR();
        loadSceneforDesktop()
    }
}

function checkForDesktopOrVR(){
    navigator.xr.isSessionSupported('immersive-vr').then((supported) => {
        supported ? VRRoom() : loadSceneforDesktop();
    })
    .catch((err) => {
        console.log("VR Immersive not supported: " + err);
    });
}